const moment = require("moment");
import { IAuthorizer } from "../infrastructure/Authorizer/IAuthorizer";
import LocalStorageAuthorizer from "../infrastructure/Authorizer/LocalStorageAuthorizer";
import { TodaysTimeState } from "source/app/presentation/Header/Center/TodaysTime/TodaysTime";
import { DeepWorkKipsTodayState } from "../presentation/Header/Tools/DeepWorkKipsToday/DeepWorkKipsToday";
import StaticSingleton from "../services/Shared/StaticSingleton";
import { ESharedComponent } from "../services/UI/State/ESharedComponent";
import { State } from "../services/UI/State/State";

class Player extends StaticSingleton<Player> {
    private authorizer: IAuthorizer = LocalStorageAuthorizer;

    public get IsSignedIn(): boolean {
        return this.authorizer.IsSignedIn();
    }

    public get userName(): string {
        return this.authorizer.GetUserName();
    }

    public get birthday(): moment.Moment {
        //TODO: Store this in database
        return moment("1985-01-15", "YYYY-MM-DD");
    }

    public get isGoalTrackingDisabled(): boolean {
        return true;
    }

    public get HasMetDailyTarget(): boolean {
        const dwktstate = State.ReadClass<DeepWorkKipsTodayState>(
            ESharedComponent.DeepWorkKipsToday
        );
        return dwktstate ? dwktstate.state.MetDailyTarget : false;
    }

    public get IsTooFarAhead(): boolean {
        const todaysTimeState = State.ReadClass<TodaysTimeState>(
            ESharedComponent.TodaysTime
        );
        return todaysTimeState
            ? todaysTimeState.state.playerTooFarAhead
            : false;
    }

    startingHour: number = 6;

    endingHour: number = 23;

    aheadAfterMinutes: number = 240;

    deepWorkKipsTarget: number = 300;

    // WARNING: Changing this numbe will change
    // the days left on all goals
    initialGoalDaysLeft: number = 30;

    maxCalories = 1890;

    targetWeight = 162.5;
    targetProtein = 0.7 * this.targetWeight;
}

export default new Player();
